import { Button, Grid, Stack, Typography } from "@mui/material"
import React from "react"
import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../../../../theme/tailwindPalette"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import { fetchGDPR, GDPRFilesQuery } from "../gdprApi"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconProp, library } from "@fortawesome/fontawesome-svg-core"
import { IconType } from "../gdprTypes"
import { fal } from "@fortawesome/pro-light-svg-icons"
import { far } from "@fortawesome/pro-regular-svg-icons"

library.add(fal, far)

const useStyles = makeStyles()((theme) => ({
    container: {
        borderRadius: ".75rem",
        padding: "2.5rem",
        boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.08)",
        border: "1px solid rgba(226, 232, 240, 1)",
        background: theme.palette.common.white,
    },
    folderTitle: {
        fontWeight: 600,
        fontSize: "1rem",
        paddingBottom: ".5rem",
        color: tailwindPalette.slate[600],
        borderBottom: `1px solid ${tailwindPalette.slate[300]}`,
    },
    fileItem: {
        display: "flex",
        justifyContent: "start",
        padding: ".5rem 0",
        textTransform: "none",
        borderBottom: `1px solid ${tailwindPalette.slate[300]}`,
    },
    fileIcon: {
        width: "1.5rem",
        height: "1.5rem",
    },
    fileTitle: {
        fontSize: ".875rem",
        padding: ".5rem 0",
        color: tailwindPalette.slate[700],
    },
}))

export function GDPRContainer() {
    const { classes } = useStyles()

    const { data } = useApiQuery(fetchGDPR, {
        queryName: GDPRFilesQuery.GDPR_FILES_LIST,
        suspense: true,
        useErrorBoundary: true,
        dependencies: {},
        select: (data) => data.gdprFiles || [],
    })

    return (
        <Grid container direction="column" className={classes.container}>
            <Stack direction="column" spacing="3.75rem">
                {data?.map((folder) => (
                    <Grid container item key={folder.folder} direction="column">
                        <Typography className={classes.folderTitle}>{folder.folder}</Typography>
                        {folder.files.map((file) => (
                            <Button
                                component="a"
                                href={file.url}
                                className={classes.fileItem}
                                target="_blank"
                                key={file.title}
                            >
                                <Stack direction="row" alignItems="center" spacing="1rem">
                                    <Typography className={classes.fileTitle}>{file.title}</Typography>
                                    {file.icon.type === IconType.IMAGE_URL && (
                                        <img src={file.icon.url} alt={file.title} className={classes.fileIcon} />
                                    )}
                                    {file.icon.type === IconType.FONT_AWESOME && (
                                        <FontAwesomeIcon
                                            color={file.icon.color}
                                            icon={file.icon.spec.split(" ") as IconProp}
                                        />
                                    )}
                                </Stack>
                            </Button>
                        ))}
                    </Grid>
                ))}
            </Stack>
        </Grid>
    )
}
